import { Component, Vue } from 'vue-property-decorator';
import LoaderComponent from '@/components/loader/loader.component.vue';

// Services
import LoginService from '@/core/services/login.service.ts';
import firebase from '../../core/config/firebase.config';

@Component({
  components: {
    LoaderComponent
  },
})
export default class Login extends Vue {

  loginService: any = new LoginService();
  isLoading: boolean = false;
  loginSession: boolean = true;
  isNewPassword: boolean = false;
  recoverPassword: boolean = false;
  reverse: boolean = false;
  messagePassword: boolean = false;
  messageEmail: boolean = false;
  modal: boolean = false;
  error: boolean = false;
  genericErr: any = [];
  email: string = "";
  password: string = "";
  confirm_password: string = "";
  isErrorServer: boolean = false;

  mounted(){
    const _ = this;
    let urlParser: any = location.href.split('/');
    console.log(urlParser, ' DD');
    urlParser = urlParser[3];
    console.log(urlParser, 'url')
    urlParser.includes('recover') || urlParser.includes('new') ?
    _.changePassword() : urlParser;


    _.checkToken();
    // _.openRecoverPassword();
  }

  changePassword(){
    const _ = this;
    _.isNewPassword = true;
    _.loginSession = false;
  }

  openRecoverPassword(){
    const _ = this;
    _.genericErr = [];
    _.loginSession = false;
    _.reverse = true;
    _.recoverPassword = true;
    _.messageEmail = false;
  }

  reverseLogin(){
    const _ = this;
    _.genericErr = [];
    _.loginSession = true;
    _.reverse = false;
    _.recoverPassword = false;
    _.messagePassword = false;
    _.messageEmail = false;
  }

  messageNewPassword(){
    const _ = this;
    _.genericErr = [];
    _.messagePassword = true;
  }

  login(){
    const _ = this;
    let permissionsObj;
    let user = {
      email: _.email.replace(/\s/g, ''),
      password: _.password
    };
      _.isLoading = true;
      firebase.auth().signInWithEmailAndPassword(_.email.replace(/\s/g, ''), _.password)
      .then((userCredential) => {
        console.log(userCredential, 'userCredential')
        localStorage.setItem('tk_auth', "R&aANrCs4$p#cg!M");
        _.$router.push('/evaluated')
      })
      .catch((err: any) => {
        console.log(err, 'err');
        _.genericErr = [];
        _.isLoading = false;
        _.modal = true;
        _.error = true;
        _.genericErr.push("El correo ó contraseña no coinciden con tu usuario.");
      })
  }

  edit(){
    const _ = this;
    let user = {
      password: _.password,
    };

    let token: any = location.href.split("=");
    token = token[1];
    console.log(token, 'token');
    _.isLoading = true;
    _.loginService.edit(user, token).then((data: any) => {
      console.log(data);
      _.isErrorServer = false;
      setTimeout(() => {
        _.isLoading = false;
        _.isNewPassword = false;
        _.messagePassword = true;
      }, 1500)
    })
    .catch((err: any) => {
      _.modal = true;
      _.error = true;
      _.isErrorServer = true;
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
  }

  restorePassword(){
    const _ = this;
    let user = {
      email: _.email
    };
    _.isLoading = true;
    console.log(_.isLoading, 'loader')
    _.genericErr = [];
    _.loginService.restorePassword(user).then((data: any) => {
      setTimeout(() => {
        _.isLoading = false;
        _.recoverPassword = false;
        _.messageEmail = true;
        _.reverse = false;
      }, 1500)
    })
    .catch((err: any) => {
      _.modal = true;
      _.error = true;
      _.genericErr.push('El correo no está registrado, por favor veríficalo.');
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
  }

  checkToken(){
    const _ = this;
    if(localStorage.getItem('tk_auth') != null) {
      _.$router.push('/evaluated')
    }
  }


//validations
  validations(email = '', password = ''){
    const _ = this;
    console.log(email, password, ' User in validations');
    _.genericErr = [];
    let emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    _.genericErr = [];
    if(!emailRegex.test(email.replace(/\s/g, '').toLowerCase()) && email != ''){
      _.genericErr.push("Correo invalido");
    }
    if(email == ''){
      _.genericErr.push("Por favor escribe un correo");
    }
    if(password == ''){
      _.genericErr.push("Por favor escribe una contraseña");
    }
    if(password.length < 3 && password != ''){
      _.genericErr.push("La contraseña debe tener minimo 3 caracteres");
    }
    if(_.genericErr.length > 0){
      _.modal = true;
      _.error = true;
      return;
    }
    _.login()
  }

  ValidationNewPassword(password = '', confirm_password = ''){
    const _ = this;
    _.genericErr = [];
    if(password == ''){
      _.genericErr.push("Por favor escribe una contraseña");
    }
    if(password.length < 3 && password != ''){
      _.genericErr.push("La contraseña debe tener minimo 3 caracteres");
    }
    if(password != confirm_password){
      _.genericErr.push("Las constraseñas no coinciden");
    }
    if(_.genericErr.length > 0){
      _.modal = true;
      _.error = true;
      return;
    }
    _.edit()
  }

  validationEmail(email = ''){
    const _ = this;
    let emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    _.genericErr = [];
    if(!emailRegex.test(email.toLowerCase()) && email != ''){
      _.genericErr.push("Correo invalido");
    }
    if(email == ''){
      _.genericErr.push("Por favor escribe un correo");
    }
    if(_.genericErr.length > 0){
      _.modal = true;
      _.error = true;
      return;
    }
    _.restorePassword()
  }
}
